import {
  REBRAND_SELECTION_STYLES,
  REBRAND_T1_ACTIVE_COLOR,
  REBRAND_T1_HOVER_COLOR,
  REBRAND_T1_PRIMARY_COLOR,
  REBRAND_T1_TEXT_COLOR,
  REBRAND_T2_ACTIVE_COLOR,
  REBRAND_T2_HOVER_COLOR,
  REBRAND_T2_PRIMARY_COLOR,
  REBRAND_T2_TEXT_COLOR,
  REBRAND_T3_ACTIVE_COLOR,
  REBRAND_T3_HOVER_COLOR,
  REBRAND_T3_PRIMARY_COLOR,
  REBRAND_T3_TEXT_COLOR,
} from '@/styles';
import styled from '@emotion/styled';
import { Button } from '@paypalcorp/pp-react-buttons-weasley-v7';

export const ButtonPPReactV7 = styled(Button)`
  width: 100%;
  margin: 0 0 24px;
`;

/* stylelint-disable declaration-no-important */
/**
 * @param activeColor - The color to use when the button is active.
 * @param hoverColor - The color to use when the button is hovered.
 * @param primaryColor - The color to use for the primary background color.
 * @param textColor - The color to use for the text.
 * @returns A button component using the updated styling.
 */
const getRebrandButtonComponent = (
  activeColor: string,
  hoverColor: string,
  primaryColor: string,
  textColor: string,
) => styled(ButtonPPReactV7)`
  /**
 * Normally we should would avoid using "!important" but
 * we don't have much choice here since we are overwriting
 * pp-react v6 and v7 styling.
 */
  &:active {
    background-color: ${activeColor} !important;
  }

  &:hover {
    background-color: ${hoverColor} !important;
    /* Normally we wouldn't want to repeat this rule, but since we have
    to use the !important flag, it is getting overwritten and we have to
    verbosely duplicate it */
    &:active {
      background-color: ${activeColor} !important;
    }
  }
  /* V8 focus are not applied while the button is active. */
  &:focus:not(:active) {
    ${REBRAND_SELECTION_STYLES}
  }
  border: none !important;
  height: 48px;
  background-color: ${primaryColor} !important;
  /* PPV7 injects "after" styles, this counteracts them */
  &::after {
    all: unset !important;
  }

  color: ${textColor} !important;
`;

export const RebrandButtonT1 = getRebrandButtonComponent(
  REBRAND_T1_ACTIVE_COLOR,
  REBRAND_T1_HOVER_COLOR,
  REBRAND_T1_PRIMARY_COLOR,
  REBRAND_T1_TEXT_COLOR,
);
export const RebrandButtonT2 = getRebrandButtonComponent(
  REBRAND_T2_ACTIVE_COLOR,
  REBRAND_T2_HOVER_COLOR,
  REBRAND_T2_PRIMARY_COLOR,
  REBRAND_T2_TEXT_COLOR,
);
export const RebrandButtonT3 = getRebrandButtonComponent(
  REBRAND_T3_ACTIVE_COLOR,
  REBRAND_T3_HOVER_COLOR,
  REBRAND_T3_PRIMARY_COLOR,
  REBRAND_T3_TEXT_COLOR,
);
